export default {
    REST_API_KEY: '89c74a1cbdb4756b2d3fd1de82aaec44',
    REDIRECT_URI: 'https://friday11am.com/auth/callback',
    SIGN_REDIRECT_URI: 'https://friday11am.com/sign/callback'
    // REDIRECT_URI: 'http://localhost:3000/auth/callback',
    // SIGN_REDIRECT_URI: 'http://localhost:3000/sign/callback'
}